import { watch } from 'vue'
import { useAuthStore } from '@/ContextTab/stores/auth/auth'
import {
  getCorrelationId,
  setRequestHeaders,
  X_CORRELATION_ID,
  X_SESSION_ID,
} from '@/ContextTab/services/apiClient'


export function useSessionWatcher() {

  const authStore = useAuthStore()

  watch(() => authStore.sessionId, (sessionId) => {
    setRequestHeaders({
      [X_SESSION_ID]: sessionId,
      [X_CORRELATION_ID]: getCorrelationId(sessionId),
    })
  }, {
    immediate: true,
  })
}
